
export function sanitize_id(ele_id) {
    return ele_id.replace(/[^a-zA-Z0-9]/g, "_")
}